import React, { useState } from "react";
import _ from "lodash";
import Swiper from "react-slick";

import { Group } from "./Group";
import { AgeGroupSliderSettings } from "../../utils/slider";
import { useArchiveContext } from "../../context/archive.context";

export const AgeGroups = () => {
	const { ageGroups, selectQueryParams, selectedAgeGroupId } =
		useArchiveContext();

	const [groups, setGroups] = useState(() => {
		if (!selectedAgeGroupId) return ageGroups;

		const selectedGroupIdx = _.findIndex(
			ageGroups,
			(i) => i.id === +selectedAgeGroupId
		);

		if (selectedGroupIdx === -1) return ageGroups;

		ageGroups[selectedGroupIdx].selected = true;

		return ageGroups;
	});

	const [bigSize, setBigSize] = useState(true);
	const [selected, setSelected] = useState(false);

	function onSelect(id) {
		const changedGroups = groups.map((item) => {
			if (item.id == id) item.selected = !item.selected;
			else item.selected = false;

			return item;
		});

		const isSelectedItem = _.findIndex(changedGroups, (item) => item.selected);

		if (isSelectedItem != -1) {
			selectQueryParams({ ageGroup: changedGroups[isSelectedItem].id });

			setSelected(true);
		} else {
			setSelected(false);

			selectQueryParams({ ageGroup: null });
		}
		setGroups(changedGroups);
	}

	function onHover() {
		if (!selected) setBigSize(false);
	}

	function outHover() {
		if (!selected) setBigSize(true);
	}

	return (
		<div className="AgeGroupHomeSection">
			<div className="wrapHomeAgeGroup-2">
				<div className="MuiGrid-root main-container root-4 rootSlide-3 MuiGrid-container">
					<div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12">
						<div className="swipeRootWrap-31 swipeRootWrap-32">
							<div className="swiper-container">
								<div
									className="swiper-wrapper"
									style={{ position: "relative" }}
								>
								
									<Swiper {...AgeGroupSliderSettings}>
										{groups &&
											groups.length &&
											groups.map((item) => (
												<Group
													key={item.title}
													data={item}
													onSelect={onSelect}
													onHover={onHover}
													outHover={outHover}
													bigSize={bigSize}
												/>
											))}
									</Swiper>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
